import { css, Theme } from '@emotion/react'

export const container = (theme: Theme) => css`
  margin: 0 auto;
  max-width: 1142px;
  padding: ${theme.spacing(3)};
`

export const headerWrapper = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`

export const header = (theme: Theme) => css`
  padding: ${theme.spacing(1, 0)};

  font-weight: 700;
`

export const tabs = (theme: Theme) => css`
  margin: ${theme.spacing(5, 0, 3)};
`
